/* @HEADER
 * @version 1.1.289 | 2026-10-18
 * @purpose The hint «Карточка в пространстве «X»» with a button that goes there and a close button — shown when «Подсветить на доске» finds a card in another space (ZVX-3530). Reuses InlineNotice for the message row; no timeout, it stays until the person acts.
 * @sidecar SearchElsewhereNotice.tsx.header.md
 * @layer app | @hex adapter | @ctx search
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-7685

import { InlineNotice } from '../ui/InlineNotice';
import { useMessages } from '../shared/i18n/useMessages';
import { SEARCH_ELSEWHERE_TESTIDS } from './search-elsewhere.testids';
import './SearchElsewhereNotice.css';

export interface SearchElsewhereNoticeProps {
  /** The name of the space the card is in. */
  spaceName: string;
  onGo: () => void;
  onClose: () => void;
}

export function SearchElsewhereNotice({ spaceName, onGo, onClose }: SearchElsewhereNoticeProps) {
  const m = useMessages();
  return (
    <div data-testid={SEARCH_ELSEWHERE_TESTIDS.notice} className="search-elsewhere-notice">
      <InlineNotice
        message={m.kanban.cmdPalette.elsewhereHint.replace('{space}', spaceName)}
        testId={`${SEARCH_ELSEWHERE_TESTIDS.notice}-message`}
        onClose={onClose}
        dismissible={false}
      />
      <div className="search-elsewhere-notice__actions">
        <button
          type="button"
          className="search-elsewhere-notice__go"
          data-testid={SEARCH_ELSEWHERE_TESTIDS.go}
          onClick={onGo}
        >
          {m.kanban.cmdPalette.elsewhereGo.replace('{space}', spaceName)}
        </button>
        <button
          type="button"
          className="search-elsewhere-notice__close"
          data-testid={SEARCH_ELSEWHERE_TESTIDS.close}
          aria-label={m.kanban.cmdPalette.elsewhereClose}
          onClick={onClose}
        >
          ×
        </button>
      </div>
    </div>
  );
}
